import { IInduccionResultadoModel } from "../../interfaces/induccion/IInduccionResultadoModel";

export class SolicitudPersonaAutorizacionModel {
    idSolicitudPersona: number;
    idAccesoPersonal: number;
    autorizado: boolean;
    rechazado: boolean;

    constructor(){
        this.idSolicitudPersona = 0;
        this.idAccesoPersonal = 0;
        this.autorizado = false;
        this.rechazado = false;        
    }
}

export class SolicitudesPersonaAutorizacionesModel {
    listaSolicitudesPersonal: SolicitudPersonaAutorizacionModel[];
    idSolicitud: number;
    constructor(){
        this.listaSolicitudesPersonal = new Array<SolicitudPersonaAutorizacionModel>();
        this.idSolicitud=0;
    }
}